import request from '@/utils/request';

const userApi = {
  googleLogin: '/users/google/credential',
  Login: '/users/login',
  Logout: '/users/signout',
  ForgePassword: '/users/changePassword',
  Register: '/users/register',
  twoStepCode: '/users/2step-code',
  SendSms: '/users/sms',
  SendSmsErr: '/users/sms_err',
  // get my info
  UserInfo: '/users/getUser',
  UserMenu: '/users/nav',
  Search: '/users/search',
  deleteUser: '/users/del',
  subscribe: '/users/subscribe',
  getLog: '/users/log',
};

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
export function login(parameter) {
  return request({
    url: userApi.Login,
    method: 'post',
    data: parameter,
  });
}

export function googleLogin(parameter) {
  return request({
    url: userApi.googleLogin,
    method: 'post',
    data: parameter,
  });
}

export function getSmsCaptcha(parameter) {
  return request({
    url: userApi.SendSms,
    method: 'post',
    data: parameter,
  });
}

export function getInfo() {
  return request({
    url: userApi.UserInfo,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    data: {},
  });
}

export function getCurrentUserNav() {
  return request({
    url: userApi.UserMenu,
    method: 'get',
  });
}

export function search(parameter) {
  return request({
    url: userApi.Search,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    data: parameter || {},
  });
}

export function deleteUser(parameter) {
  return request({
    url: userApi.deleteUser,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    data: parameter || {},
  });
}

export function subscribe(parameter) {
  return request({
    url: userApi.subscribe,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    data: parameter || {},
  });
}

export function getLog(parameter) {
  return request({
    url: userApi.getLog,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    data: parameter || {},
  });
}

export function logout() {
  return request({
    url: userApi.Logout,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}

/**
 * get user 2step code open?
 * @param parameter {*}
 */
export function get2step(parameter) {
  return request({
    url: userApi.twoStepCode,
    method: 'post',
    data: parameter,
  });
}
